<template>
    <div class="uk-padding uk-background-muted">
        <div class="uk-container">
            <h1 class="uk-text-center">Recruitment and Admissions</h1>
            <h2 class="uk-text-center uk-margin-remove-top">Freshman 2022 Grants</h2>
            <div class="uk-text-center">
              If you applied and received an acceptance, along with meeting the other criteria for a grant, then one of these grants could be yours!
                <br>
              Please review a category below that applies to you for more information and click "Apply Now" for the application form.
            </div>
            <div class="uk-alert-primary uk-text-center" uk-alert>
                <p>DEADLINE FOR ALL GRANTS APPLICATION IS APRIL 30, 2022</p>
            </div>
            <div class="uk-alert">

            </div>
            <hr>
            <br>
            <div class="uk-child-width-1-2@m" uk-grid>
                <div>
                    <div class="uk-card uk-card-default uk-card-body">
                        <div class="uk-child-width-1-1@m" uk-grid>
                            <div class="uk-text-left">
                                <h3 class="uk-text-left uk-text-bold">Fall Grants <span  style="font-size: small; color: #033860;"><i>20 grants available</i></span></h3>
                                <hr>
<!--                                <p class="uk-text-left uk-text-small">
                                    Citizen of Jamaica either by birth or naturalization.
                                </p>-->
                                <ul class="uk-list uk-list-bullet">
                                    <b>Eligibility Criteria</b>
                                    <li class="uk-text-small">Receive an acceptance letter for Fall 2022</li>
                                    <li class="uk-text-small">Minimum of 5 CSEC’s / BSEC passes range 1-2 (or the equivalent) for the area of discipline with no more than one grade 3. CAPE is optional</li>
                                    <li class="uk-text-small">Been in leadership position at school, church or community (references required).</li>
                                    <li class="uk-text-small">Participated in acts of volunteerism</li>
                                    <span class="uk-text-primary uk-text-small">* Conditions apply</span>
                                </ul>
                                <hr>
                                <ul class="uk-list uk-list-bullet uk-text-small">
                                    <b>Shortlisted applicants will be asked to submit two paragraphs (350 - 500 words) stating:</b>
                                    <li>Two reasons why you should be selected as a grant recipient.</li>
                                    <li>How you believe NCU will help you build character, creativity and competence</li>

                                </ul>
                                <a href="https://forms.gle/b9j8aPWPQxiKj6aeA" target="_blank" class="uk-align-right@m uk-button uk-button-secondary uk-text-capitalize" style="background: #033860; color: gold;">Apply Now</a>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AdmissionGrants"
    }
</script>

<style scoped>

</style>